export abstract class Icon {
  type: IconType;
  name: string;
  constructor(name: string, type: IconType) {
    this.name = name;
    this.type = type;
  }
}

export enum IconType {
  MAT_ICON,
  SVG
}

export class MatIcon extends Icon {
  constructor(name: string) {
    super(name, IconType.MAT_ICON);
  }
}

export class SvgIcon extends Icon {
  constructor(name: string) {
    super(name, IconType.SVG);
  }
}
